import { apiClient } from './api';

export interface Employee {
  id: number | null;
  emp_no: string;
  name: string;
  department: string;
  position: string;
  status?: string; // 직원 상태 (ACTIVE, RESIGNED 등)
  averageCR: number;
  totalCR: number;
  year?: number;
  projectCount?: number;
  calculationDetails?: string;
}

export interface CRDetail {
  employeeId: number;
  projectId: number;
  projectName: string;
  projectRevenue: number;
  inputCost: number;
  cr: number;
  yearlyMM: number;
}

export const crApi = {
  // CR 데이터가 있는 연도 목록 조회
  getAvailableYears: async (): Promise<number[]> => {
    return await apiClient.get<number[]>('/cr/available-years');
  },

  // 직원별 CR 목록 조회 (연도별)
  getEmployeeCRList: async (year?: number): Promise<Employee[]> => {
    const endpoint = year ? `/cr?year=${year}` : '/cr';
    return await apiClient.get<Employee[]>(endpoint);
  },
};